<template>
  <b-card>
    <layout-loading v-if="itemLoading" />
    <b-form
      v-if="render"
      class="p-2"
    >
      <b-row class="mb-2">
        <b-col md="12">
          <h3>{{ $t('counselings.consultantInfo') }}</h3>
          <hr>
        </b-col>
        <b-col md="6">
          <h4>{{ form.userId.fullName + " - " + form.userId.phoneNumber }}</h4>
        </b-col>
        <b-col md="6">
          <h4>{{ $t('general.lastStatus') }} : {{ $t(`counselings.${form.status}`) }}</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-col
            md="12"
            class="mb-2"
          >
            <h5>{{ $t('counselings.consultantAssign') }}</h5>
          </b-col>
          <b-form-group
            label-for="counseling-consultant"
            class="ml-2"
            :state="validateState('consultant')"
          >
            <v-select-custom
              id="counseling-consultant"
              v-model="form.consultant"
              :custom-props="{ label: 'fullName' }"
              :options="userOptions"
              @open="fetchUsersByRole({ role: 'consultant' })"
              @search="fetchUsersByRole({ role: 'consultant', 'search' : $event })"
            />
            <b-form-invalid
              id="input-consultantId-feedback"
              :label="$t('general.consultant')"
              :validator="$v.form.consultant"
              :is-bootstrap="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t("general.isSubmit") : $t("general.submit") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t("general.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>
<script>
import {
  BButton, BCard, BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import '@/components/BFileInput/index.vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import Ripple from 'vue-ripple-directive'
import VSelectCustom from '@/components/VSelectCustom/index.vue'
import '@/components/VSelectCustom/VSelectOption.vue'
import { required } from 'vuelidate/lib/validators'
import useCounselingsList from './useCounselingsList'

export default {
  name: 'CounselingEdit',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInvalid,
    BRow,
    LayoutLoading,
    VSelectCustom,
  },
  directives: {
    Ripple,
  },
  validations() {
    return {
      form: {
        consultant: {
          required,
        },
      },
    }
  },
  setup() {
    const {
      fetchItem,
      fetchUsersByRole,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
      userOptions,
    } = useCounselingsList()
    return {
      fetchItem,
      fetchUsersByRole,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
      userOptions,
    }
  },
  data() {
    return {
      consultantOptions: [],
    }
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.item ? this.item && Object.keys(this.item).length : true
    },
  },
  created() {
    this.fetchItem(this.itemId).then(() => {
      this.fetchUsersByRole({
        role: 'consultant',
      }).then(res => {
        this.consultantOptions = res
      })
    })
  },
  methods: {
    validateState(name) {
      const {
        $dirty,
        $error,
      } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    submitForm() {
      const data = {
        consultantId: this.form.consultant ? this.form.consultant._id : null,
      }
      this.updateItem(this.itemId, data)
    },
  },
}
</script>
